import { useLangStore, type Lang } from "./langStore";

// Locale por idioma del UI. Inglés → en-GB (formato europeo DD/MM/AAAA, sin la
// ambigüedad del MM/DD americano). Los informes PDF llevan su propio formato.
const LOCALE: Record<Lang, string> = { es: "es-ES", en: "en-GB" };

export function localeFor(lang: Lang): string {
  return LOCALE[lang];
}

// ── Funciones puras (para módulos sin acceso al hook; se les pasa `lang`) ──────
export function fmtDate(d: string | number | Date, lang: Lang,
                        opts?: Intl.DateTimeFormatOptions): string {
  return new Date(d).toLocaleDateString(LOCALE[lang], opts);
}
export function fmtDateTime(d: string | number | Date, lang: Lang,
                            opts?: Intl.DateTimeFormatOptions): string {
  return new Date(d).toLocaleString(LOCALE[lang], opts);
}
export function fmtNum(n: number, lang: Lang, opts?: Intl.NumberFormatOptions): string {
  return n.toLocaleString(LOCALE[lang], opts);
}

// ── Hook (para componentes): formatea con el idioma activo y re-renderiza al cambiarlo ──
export function useFmt() {
  const lang = useLangStore((s) => s.lang);
  return {
    lang,
    locale: LOCALE[lang],
    date: (d: string | number | Date, opts?: Intl.DateTimeFormatOptions) => fmtDate(d, lang, opts),
    dateTime: (d: string | number | Date, opts?: Intl.DateTimeFormatOptions) => fmtDateTime(d, lang, opts),
    num: (n: number, opts?: Intl.NumberFormatOptions) => fmtNum(n, lang, opts),
  };
}
